export default __webpack_public_path__ + "static/media/airstrapz-cbb-4.24168b0f.png";